module.exports = __webpack_public_path__ + "assets/facece0c3a92c803fec744506e45b169.mp3";